import { render, staticRenderFns } from "./local-loading.vue?vue&type=template&id=66a5f987"
import script from "./local-loading.vue?vue&type=script&lang=js"
export * from "./local-loading.vue?vue&type=script&lang=js"
import style0 from "./local-loading.vue?vue&type=style&index=0&id=66a5f987&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports